'use client';

/**
 * Dock panel view — the taskbar as a left-panel view: every open app
 * (screens v2), minimized ones dimmed. Reuses `RailDock` (in the
 * labeled `wide` variant for full-width rows). On mobile this is the
 * taskbar (the inline rail taskbar is desktop-rail-only).
 */

import { useWorkspaceItems } from '@/components/workspace/store';
import { useT } from '@/components/i18n-provider';
import { orderScreens } from '@/lib/workspaces/screens';
import { RailDock } from '@/components/workspace/rail/rail-dock';
import { RailLayoutContext } from '@/components/workspace/rail/rail-item';

export function DockView() {
  const t = useT();
  const items = useWorkspaceItems();
  const hasApps = orderScreens(items).length > 0;

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-2 py-2">
      {hasApps ? (
        <RailLayoutContext.Provider value={{ variant: 'wide' }}>
          <RailDock />
        </RailLayoutContext.Provider>
      ) : (
        <p className="px-2 py-6 text-center text-xs leading-snug text-muted-foreground">
          {t('workspace.panels.dockEmptyHint')}
        </p>
      )}
    </div>
  );
}
